import Cookies from 'js-cookie';
import { USER_ACCESS_COOKIE } from '@plataforma/utils';
import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class IdentityServerAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));

    return this.api;
  }

  ValidarUsuarioSenha(username, password) {
    const data = {
      Login: username,
      Password: password
    };

    const result = this.getAPI().getInstance('application/x-www-form-urlencoded').post(`api/account/v1/login`, data);
    return result;
  }

  ValidarUsuarioSenhaBackoffice(username, password) {

    const data = {
      username,
      password,
      grant_type: 'password',
      Scope: 'backoffice users',
      client_id: 'PlataformaBackoffice',
      client_secret: 'appSecretPlataformaApi'
    };

    const result = this.getAPI().getInstance('application/x-www-form-urlencoded').post(`connect/token`, data);
    return result;
  }

  ValidarLogarComo(username, superUserAccessToken) {

    const result = this.getAPI()
      .getInstance('application/x-www-form-urlencoded')
      .post(
        `api/account/v1/login/as`,
        { login: username },
        { headers: { Authorization: `Bearer ${superUserAccessToken}` } }
      );
    return result;
  }

  /*
    Method valid if the token to be used is from the keycloak and makes the call accordingly, with the necessary data;
    Attribute useRefreshToken refers to keycloak token;
  */
  RefreshToken() {
    const { useRefreshToken, refreshToken, } = Cookies.getJSON(USER_ACCESS_COOKIE);

    const url = useRefreshToken
      ? `${getSessionItem('API_IDENTITY_SERVER')}api/account/v1/token/refresh`
      : `${getSessionItem('API_IDENTITY_SERVER')}api/account/v1/login/refresh`;

    const result = this.getAPI()
      .getInstance(useRefreshToken && 'application/x-www-form-urlencoded')
      .post(url, useRefreshToken ? { refresh_token: refreshToken, } : {});
    return result;
  }

  async getVersion() {
    const result = await this.getAPI().getInstance().get(`/version`);
    return result;
  }
}

const api = new IdentityServerAPI();
export default api;
